import { Audio, Buttons, Images, Tweens } from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import gameData from '../gameData';
import LevelScreen from './LevelScreen';
import ABCyaLib from '@abcya/abcya_lib';
import GameScreen from './GameScreen';

export default class IntroScreen extends Phaser.Scene {
  static get KEY() { return 'IntroScreen'; }

  static get TRANSITION_COMPLETE() {return 'TRANSITION_COMPLETE';};

  create() {
    const width = this.scale.width;
    const height = this.scale.height;

    this.backgroundImage = Images.addImage(0, 0, 'background', this).setOrigin(0);
    const title = Images.addImage(0, 0, 'title', this);

    title.x = width / 2;
    title.y = 350;
    title.scaleX = 0.1;
    title.scaleY = 0.1;

    Tweens.addTween(title, 1000, { scale: 1 }, Phaser.Math.Easing.Bounce.Out);

    const rotateTween = function() {
      Tweens.addTween(title, 400, { angle: 5, yoyo: true }, Phaser.Math.Easing.Linear, () => {
        Tweens.addTween(title, 400, { angle: -5, yoyo: true }, Phaser.Math.Easing.Linear, () => {
          rotateTween();
        });
      });
    };

    rotateTween();

    this.goButton = Buttons.addButton(width / 2, height / 2 + 383, 'BTN_play', 'BTN_play', 'click', () => {this.goClicked();}, this);

    buttonTween(this.goButton, 0.95, 400);

    if (!gameData.WIN_SEEN) {
      Audio.playOneShot('jingle', this, 1, true);
    }
    else {
      gameData.WIN_SEEN = false;
      for (const key in gameData.levels) {
        gameData.levels[key].isCompleted = false;
      }
      gameData.variantLevelIndex = 0;
    }
  }

  goClicked() {
    this.goButton.removeInteractive();
    if (ABCyaLib.Environment.instance.gameConfig.levels === null) {
      horizontalScreenTransisition(this, LevelScreen.KEY);
    }
    else {
      // go directly to the game, need to set the level to go to
      gameData.currentLevel = gameData.levels[ABCyaLib.Environment.instance.gameConfig.levels[0]];
      horizontalScreenTransisition(this, GameScreen.KEY);
    }
  }
}

export function buttonTween(button, scale, duration) {
  Tweens.addTween(button, duration, { scaleX: scale, yoyo: true }, Phaser.Math.Easing.Linear, () => {
    Tweens.addTween(button, duration, { scaleY: scale, yoyo: true }, Phaser.Math.Easing.Linear, () => {
      buttonTween(button, scale, duration);
    });
  });
}

export function horizontalScreenTransisition(currentScene, nextSceneKey, rightToLeft = true) {
  let startX; let endX;
  if (rightToLeft) {
    startX = 768;
    endX = -768;
  }
  else {
    startX = -768;
    endX = 768;
  }

  currentScene.scene.run(nextSceneKey);
  currentScene.scene.sendToBack(nextSceneKey);
  const sceneRef = currentScene.scene.get(nextSceneKey);

  sceneRef.events.once('start', () => {
    const currentCamera = currentScene.cameras.main;
    const nextCamera = sceneRef.cameras.main;

    nextCamera.setPosition(startX, 0);

    // Does not use ABCYA package Tweens.addTween to maintain grainular control of parent of tween

    if (!currentCamera || !nextCamera)console.log(currentCamera, nextCamera, currentScene, nextSceneKey);

    currentScene.tweens.add({
      targets: currentCamera,
      x: endX,
      duration: 1000,
      ease: Phaser.Math.Easing.Linear
    });

    currentScene.tweens.add({
      targets: nextCamera,
      x: 0,
      duration: 1000,
      ease: Phaser.Math.Easing.Linear,
      onComplete: () => {
        currentScene.scene.stop(currentScene.scene.key);
      }
    });
  });
}